import React, { useLayoutEffect } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

function hideAppBoot() {
  const boot = document.getElementById('app-boot');
  if (boot) boot.classList.add('is-hidden');
  document.documentElement.classList.add('app-hydrated');
}

function AppRoot() {
  useLayoutEffect(() => {
    hideAppBoot();
  }, []);

  return (
    <HelmetProvider>
      <App />
    </HelmetProvider>
  );
}

const container = document.getElementById('root');

/** Set before render so intro logic can match prerendered HTML on first paint. */
if (typeof window !== 'undefined') {
  window.__DATABIQS_HYDRATE_SKIP_INTRO__ = Boolean(container?.hasChildNodes());
}

const appTree = (
  <React.StrictMode>
    <AppRoot />
  </React.StrictMode>
);

/**
 * react-snap writes pre-rendered markup into #root.
 * Hydrate that HTML on first load; otherwise do a normal client render (dev / fresh builds).
 */
if (container.hasChildNodes()) {
  hydrateRoot(container, appTree);
} else {
  createRoot(container).render(appTree);
}

reportWebVitals();
